<template>
  <div id="app">
    <div class="tab">
      <ul>
        <li><span @click="toCompleteTab" style="cursor:pointer">正在搜索比对任务</span></li>
        <li><span class="active">已完成任务</span></li>
      </ul>
    </div>
    <div class="cnt">
      <ul>
        <li  v-for="(process,key) in processList" :key="key">
          <img class="pic" :src="process.pictureList!=null?process.pictureList[0].link:''"/>
          <div class="info">
            <div class="title">{{process.title}} <span style="margin-left:20px;color:#666">监测数量: {{process.picCount}}</span><span style="margin-left:20px;color:#666">结果数量: {{process.resCount}}</span></div>
         
            <div class="web_lable">比对网址</div>
            <div class="webs">
              <span v-for="(web,key2) in process.platformWebList" :key="key2">
                {{web.title}}&nbsp;
              </span>
            </div>
            <div class="date">时间：{{process.startDate}}&nbsp;至&nbsp;{{process.endDate}}</div>
          </div>
          <div class="opt">
            <button @click="seeReport(process.taskId)" class="see btn">查看报告</button>
            <button class="download btn" @click="dowFile(process.taskId)">下载报告</button>
          </div>
          <div class="clear_both"></div>
        </li>
      </ul>
    </div>
    <div  style="color:#666;padding-top:100px;padding-left:20px" v-show="isLoading">正在加载...</div>
    <div style="color:#666;padding-top:100px;padding-left:20px" v-show="emptyData">抱歉，您没有完成的任务</div>
  </div>
</template>
<script>
import {processApi} from '@/service/allApi'
export default {
  data(){
    return {
      processList:[],
      isLoading:true,
      emptyData:false
    }
  },
  mounted(){
    this.loadTask();
  },
  methods: {
    toCompleteTab(){
      window.parent.toUrl("/my?page=searching")
    },
    seeReport(taskId){
      window.location.href = "/report?taskId=" + taskId
    },

    loadTask(){
      
      const options = {
        status:1
      }
      const that = this
      that.isLoading = false
      processApi(options).then((res)=>{
        if(res.data.code == 100){
        
          if(res.data.list && res.data.list.length > 0){
            that.processList = res.data.list
            // console.log(res.data.list)
          }else{
            that.emptyData = true
          }
          
        }
        that.isLoading = false
      }).catch((error)=>{
        that.$message.error("系统出错");
        that.isLoading = false
      })
    },
    async  dowFile(taskId){

      for(var i=0;i<this.processList.length;i++){
        if(this.processList[i].taskId == taskId){
          if(this.processList[i].resCount <= 0){
              this.$message({
                message: '不存在相似处，下载报告失败',
                type: 'error'
              });
              return
          }
        }
      }
      
      // var data = {
      //     taskId:this.taskId
      // }
      //下载文件
      window.open('/api/file/resultDow?taskId='+taskId, '_blank')
      // window.open("http://www.dmid.com.cn/api/file/resultDow?taskId="+taskId, '_blank')
    }
  },
}

</script>
<style scoped src="../../../static/css/Common.css"></style>
<style scoped src="../../../static/css/History.css"></style>


// WEBPACK FOOTER //
// src/components/iframe/History.vue